module.exports = __webpack_public_path__ + "static/media/ShaferSuggs.b7c8513b.jpg";